/* ============================================================
   Dependencies extracted from the old theme (global.js) so the
   <modal-opener> / <modal-dialog> pair used in lp-product-variants
   can work on the LP without loading global.js.
============================================================ */

if (typeof window.getFocusableElements !== 'function') {
    window.getFocusableElements = function (container) {
        return Array.from(
            container.querySelectorAll(
                "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
            )
        );
    };
}

if (typeof window.trapFocusHandlers === 'undefined') {
    window.trapFocusHandlers = {};
}

if (typeof window.trapFocus !== 'function') {
    window.trapFocus = function (container, elementToFocus = container) {
        const elements = window.getFocusableElements(container);
        const first = elements[0];
        const last  = elements[elements.length - 1];

        window.removeTrapFocus();

        window.trapFocusHandlers.focusin = (event) => {
            if (event.target !== container && event.target !== last && event.target !== first) return;
            document.addEventListener('keydown', window.trapFocusHandlers.keydown);
        };

        window.trapFocusHandlers.focusout = function () {
            document.removeEventListener('keydown', window.trapFocusHandlers.keydown);
        };

        window.trapFocusHandlers.keydown = function (event) {
            if (event.code.toUpperCase() !== 'TAB') return;

            if (event.target === last && !event.shiftKey) {
                event.preventDefault();
                first.focus();
            }

            if ((event.target === container || event.target === first) && event.shiftKey) {
                event.preventDefault();
                last.focus();
            }
        };

        document.addEventListener('focusout', window.trapFocusHandlers.focusout);
        document.addEventListener('focusin',  window.trapFocusHandlers.focusin);

        elementToFocus.focus();

        if (
            elementToFocus.tagName === 'INPUT'
            && ['search', 'text', 'email', 'url'].includes(elementToFocus.type)
            && elementToFocus.value
        ) {
            elementToFocus.setSelectionRange(0, elementToFocus.value.length);
        }
    };
}

if (typeof window.removeTrapFocus !== 'function') {
    window.removeTrapFocus = function (elementToFocus = null) {
        document.removeEventListener('focusin',  window.trapFocusHandlers.focusin);
        document.removeEventListener('focusout', window.trapFocusHandlers.focusout);
        document.removeEventListener('keydown',  window.trapFocusHandlers.keydown);

        if (elementToFocus) elementToFocus.focus();
    };
}

if (typeof window.pauseAllMedia !== 'function') {
    window.pauseAllMedia = function () {
        document.querySelectorAll('.js-youtube').forEach((video) => {
            video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        });
        document.querySelectorAll('.js-vimeo').forEach((video) => {
            video.contentWindow.postMessage('{"method":"pause"}', '*');
        });
        document.querySelectorAll('video').forEach((video) => video.pause());
        document.querySelectorAll('product-model').forEach((model) => {
            if (model.modelViewerUI) model.modelViewerUI.pause();
        });
    };
}

/* ============================================================
   <modal-opener> / <modal-dialog> custom elements
============================================================ */

if (!customElements.get('modal-opener')) {
    customElements.define('modal-opener', class extends HTMLElement {
        constructor() {
            super();

            const button = this.querySelector('button');
            if (!button) return;

            button.addEventListener('click', () => {
                const modal = document.querySelector(this.getAttribute('data-modal'));
                if (modal) modal.show(button);
            });
        }
    });
}

if (!customElements.get('modal-dialog')) {
    customElements.define('modal-dialog', class extends HTMLElement {
        constructor() {
            super();

            this.querySelector('[id^="ModalClose-"]')?.addEventListener(
                'click',
                this.hide.bind(this, false)
            );

            this.addEventListener('keyup', (event) => {
                if (event.code.toUpperCase() === 'ESCAPE') this.hide();
            });

            if (this.classList.contains('media-modal')) {
                this.addEventListener('pointerup', (event) => {
                    if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
                });
            } else {
                this.addEventListener('click', (event) => {
                    if (event.target === this) this.hide();
                });
            }
        }

        connectedCallback() {
            if (this.moved) return;
            this.moved = true;
            document.body.appendChild(this);
        }

        show(opener) {
            this.openedBy = opener;
            const popup = this.querySelector('.template-popup');
            document.body.classList.add('overflow-hidden');
            this.setAttribute('open', '');
            if (popup) popup.loadContent();
            window.trapFocus(this, this.querySelector('[role="dialog"]'));
            window.pauseAllMedia();
        }

        hide() {
            document.body.classList.remove('overflow-hidden');
            document.body.dispatchEvent(new CustomEvent('modalClosed'));
            this.removeAttribute('open');
            window.removeTrapFocus(this.openedBy);
            window.pauseAllMedia();
        }
    });
}
